import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import CheckIcon from 'icons/check.svg?react';
import * as React from 'react';
import { cn } from 'utils/tailwind';

type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> & {
  invalid?: boolean;
};

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, invalid, disabled, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer size-5 shrink-0 cursor-pointer rounded-[.375rem] border border-primary-black ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50 disabled:border-gray-600 data-[state=checked]:bg-black data-[state=checked]:border-black data-[state=checked]:disabled:bg-gray-600 data-[state=checked]:disabled:border-gray-600',
      className,
      invalid && 'border-system-red',
    )}
    disabled={disabled}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center [&_svg_path]:!fill-white">
      <CheckIcon className="size-3 data-[state=checked]:[&_path]:!fill-white" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
